// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__1vc43","big":"Section_big__3VhT9"};